import React from 'react';
import PropTypes from 'prop-types';

import DiscoveredDomainsParentTableContainer from './discovered-domains-parent-table-container';
import DiscoveredSubdomainsTableContainer from './discovered-subdomains-table-container';
import TabFilterButtons from '../domain-management/tab-filter-buttons';
import TabHeaderContainer from '../domain-management/tab-header-container';

import { DOMAIN_HIERARCHY_PARENT } from '../../common/constants/definitions';

export const DiscoveredDomains = ( {
    match,
    selectedDomainFilter,
} ) => {
    return (
        <>
            <TabHeaderContainer type="discovered" />
            {
                selectedDomainFilter &&
                ( <TabFilterButtons
                    domainType="discovered"
                    match={match}
                    selectedDomainFilter={selectedDomainFilter}
                /> )
            }
            {
                selectedDomainFilter === DOMAIN_HIERARCHY_PARENT ?
                    <DiscoveredDomainsParentTableContainer /> : (
                        <DiscoveredSubdomainsTableContainer
                            selectedDomainFilter={selectedDomainFilter}
                        />
                    )}
        </>
    );
};

DiscoveredDomains.propTypes = {
    match: PropTypes.shape( {
        params: PropTypes.shape( {
            collectionId: PropTypes.string
        } ),
        url: PropTypes.string,
    } ),
    selectedDomainFilter: PropTypes.string,
};

export default DiscoveredDomains;
